import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box, useTheme } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TBloodDispensingDefaultValues } from '../../type';
import { updateBloodDispensing } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import BloodType from './BloodType';
import EducationList from './EducationList';
import Signature from './Signature';

const BloodDischarge = (
  props: SurveyDialogProps<TBloodDispensingDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { palette } = useTheme();

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TBloodDispensingDefaultValues) => {
    const { prescription, quantity, date, name, sign } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      blood_dispensing_survey: {
        prescription,
        quantity,
        date,
        name,
        sign,
      },
    };

    updateBloodDispensing(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => {
        onFail('저장에 실패하였습니다', e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        혈액불출요청서
      </Typography>
      <BloodType {...formProps} patientInfo={patientInfo} />
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <EducationList {...formProps} />
        <Signature {...formProps} />
      </Box>
      <Box sx={{ textAlign: 'right', marginTop: '30px' }}>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            color: `${palette.primary.main}`,
          }}
        >
          *해당 기록지는 한국성서대학교 간호학과 협조를 통해 제작하였습니다.
        </Typography>
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default BloodDischarge;
